module.exports = __webpack_public_path__ + "img/icon_eth.eb6e67c2.svg";